import { useTranslation } from "react-i18next";
import styles from "./Card.module.css";
import { ReactComponent as IdIcon } from "../../../assets/svg/serviceId.svg";
import { ReactComponent as MobileIcon } from "../../../assets/svg/mobile-icon.svg";
import { ReactComponent as UserIcon } from "../../../assets/svg/user.svg";
import { ReactComponent as PackageIcon } from "../../../assets/svg/package.svg";
import { ReactComponent as QuantityIcon } from "../../../assets/svg/quantity.svg";
import { Button, Tooltip } from "antd";
import { ReactComponent as CalendarIcon } from "../../../assets/svg/calendar-1.svg";
import { useLangNavigate } from "../../../hooks/useLangNavigate";

export default function AppointmentCard({
  delivery_date,
  product_name,
  mobile,
  fullname,
  id,
  quantity,
  expired_at,
}) {
  const { t, i18n } = useTranslation();
  const navigate = useLangNavigate();
  return (
    <div className={styles.CardContainer}>
      <div className={expired_at ? styles.expired : ""}>
        <span>{t("appointment.date")}</span>
        {expired_at ? (
          <CalendarIcon
            width={16}
            height={16}
            style={{
              marginInlineStart: "auto",
            }}
          />
        ) : null}
        <span>{delivery_date?.replaceAll("-", "/")}</span>
      </div>
      <div
        className={`${styles.box} ${i18n.dir() === "rtl" ? styles.rtl : ""}`}
      >
        <div>
          <PackageIcon className={styles.icon} />{" "}
          {t("service_details.product_name")}:
        </div>
        <Tooltip title={product_name} trigger="hover">
          <div className={styles.productName}>{product_name}</div>
        </Tooltip>
        <div>
          <QuantityIcon className={styles.icon} /> {t("orderdetails.quantity")}:
        </div>
        <div>{quantity}</div>
        <div>
          <IdIcon /> {t("common.id_number")}:
        </div>
        <div>{id}</div>
        <div>
          <UserIcon className={styles.icon} />
          {t("appointment.customer_name")}:
        </div>
        <div>
          {fullname?.trim() || (
            <>
              <div className="px-1">_&#8197;_</div>
            </>
          )}
        </div>
        <div>
          <MobileIcon className={styles.icon} />
          {t("appointment.customer_phone")}:
        </div>
        <div>{mobile}</div>
      </div>
      <div className={styles.cardAction}>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            navigate(`/appointment/${id}`);
          }}
        >
          {t("cart.more_details")}
        </Button>
      </div>
    </div>
  );
}
